import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FourColumnWithInputForm.js";
import Header from "./../components/headers/HeaderLight"
import { css } from "styled-components/macro"; //eslint-disable-line
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import IllustrationSrc from "images/transfer.png";
import { Button } from "reactstrap";
import { usePayments } from "hooks/usePayments.js";
import LoadingSpinner from "components/misc/LoadingSpinner.js";
import { ROUTE_PATHS } from "utils/routes.js";

const SpinnerOverlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(255,255,255,0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
    tw`md:w-7/12 mt-16 md:mt-0`,
    props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);
const Image = styled.div(props => [
    `background-image: url("${props.imageSrc}");`,
    tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`
const ButtonTw = tw(
    Button
)`px-8 py-3 font-bold rounded bg-primary-500 text-gray-100 hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300 mt-12 inline-block tracking-wide text-center px-10 py-4 font-semibold tracking-normal`;

export default function NewPaymentPage() {
    const location = useLocation();
    const selectedPayments = location.state?.selectedPayments || [];
    const [showModal, setShowModal] = useState(false);
    const [referenceNumber, setReferenceNumber] = useState("");
    const { createPayment, loading } = usePayments();
    const navigate = useNavigate();

    // Generates a random 6-digit reference number
    const generateReferenceNumber = async () => {
        let referenceNumber = "";
        referenceNumber = Math.floor(100000 + Math.random() * 900000).toString();

        selectedPayments.forEach(element => {
            element.referenceNumber = referenceNumber;
        });

        //THIS METHOD NEED TO BE REPLACED FOR UPDATE METHOD - CREATE METHOD MUST BE GENRATED IN ADMIN PAYMENT PAGE
        await createPayment(selectedPayments).then(async (response) => {
            if (!response.success) {
                referenceNumber = "";
            }
        }).catch((error) => {
            console.log("Failed to create payment: " + error);
            referenceNumber = "";
        });

        return referenceNumber;
    };

    const handleAgendarPago = async () => {
        const referenceNumber = await generateReferenceNumber();
        if (referenceNumber === "") {
            alert("Error al generar el número de referencia. Inténtalo de nuevo.");
        }
        else {
            setReferenceNumber(referenceNumber);
            setShowModal(true);
        }
    };

    const onCloseModal = () => {
        setShowModal(false);
        setReferenceNumber("");
        navigate(ROUTE_PATHS.PAYMENTS);
    };

    return (
        <>
            {loading && (
                <SpinnerOverlay>
                    <LoadingSpinner text="Loading..." />
                </SpinnerOverlay>
            )}
            {!loading && (
                <AnimationRevealPage>
                    <Header />
                    <Container>
                        <TwoColumn>
                            <ImageColumn>
                                <Image imageSrc={IllustrationSrc} />
                            </ImageColumn>
                            <TextColumn textOnLeft={true}>
                                <TextContent>
                                    <Subheading>{"Método de Pago"}</Subheading>
                                    <Heading>{<> Transferencia <span className="text-primary-500">Electrónica</span></>}</Heading>
                                    <Description>
                                        {"Llena correctamente el siguiente formulario para generar el número de referencia que necesitarás ingresar en la App de tu banco en el campo referencia y concepto."}
                                    </Description>
                                    {/** Go Back Navigation **/}
                                    <div className="items-center justify-center mb-4 mt-4">
                                        <button
                                            className="px-4 py-2 rounded-full bg-blue-200 text-black mr-4 hover:bg-gray-400 flex items-center"
                                            onClick={() => navigate(ROUTE_PATHS.PAYMENTS)}
                                        >
                                            <span style={{ fontSize: "1.25rem", lineHeight: '1.75rem', display: 'flex', alignItems: 'center' }}>&#8592;</span>
                                            <span className="font-semibold text-base mx-2 text-left flex items-center">Atrás</span>
                                        </button>
                                    </div>
                                    {/* Payments Report */}                                    
                                    <div>
                                        {selectedPayments.length === 0 ? (
                                            <div className="bg-white rounded-lg shadow p-6 my-8 mx-auto max-w-md">
                                                <h3 className="text-lg font-bold mb-4 text-gray-700 text-center">No hay pagos disponibles.</h3>
                                            </div>
                                        ) : (
                                            <div className="bg-white rounded-lg shadow p-6 my-8 mx-auto max-w-md">
                                                <h3 className="text-lg font-bold mb-4 text-gray-700 text-center">Resumen de Pagos Seleccionados</h3>
                                                {Object.entries(selectedPayments.reduce((acc, p) => {
                                                    acc[p.category] = acc[p.category] || [];
                                                    acc[p.category].push(p);
                                                    return acc;
                                                }, {})).map(([category, payments]) => (
                                                    <div key={category} className="mb-4">
                                                        <div className="bg-gray-100 px-3 py-2 rounded font-semibold text-gray-800 mb-2">{category}</div>
                                                        <table className="w-full text-sm">
                                                            <tbody>
                                                                {payments.map((p, idx) => (
                                                                    <tr key={p.id || idx} className="border-b last:border-b-0">
                                                                        <td className="py-1 text-gray-600">{p.createdDate}</td>
                                                                        <td className="py-1 text-right font-bold text-gray-900">{p.balance}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        <div className="text-right mt-2 text-blue-600 font-bold">
                                                            Total: $ {payments.reduce((sum, p) => sum + Number(String(p.balance).replace(/[^\d.]/g, '')), 0).toLocaleString()}
                                                        </div>
                                                    </div>
                                                ))}
                                                {/* Grand Total Section */}
                                                <div className="border-t pt-4 mt-6">
                                                    <div className="text-right text-xl font-bold text-primary-500">
                                                        Total General: $ {selectedPayments.reduce((sum, p) => sum + Number(String(p.balance).replace(/[^\d.]/g, '')), 0).toLocaleString()}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <ButtonTw
                                        disabled={selectedPayments.length === 0}
                                        className="my-2"
                                        size="lg"
                                        style={{ position: 'relative' }}
                                        onClick={handleAgendarPago}
                                    >
                                        Agendar Pago
                                    </ButtonTw>
                                    {/* Confirmation Modal */}
                                    {showModal && (
                                        <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: 'rgba(108,117,125,0.65)' }}>
                                            <div className="bg-white rounded-lg shadow-lg p-8 max-w-sm w-full relative">
                                                <h3 className="text-xl font-bold text-center text-primary-500 mb-4">Pago Agendado</h3>
                                                <p className="text-center text-gray-700 mb-2">Tu número de referencia es:</p>
                                                <div className="text-center text-3xl font-mono font-bold text-blue-600 mb-6">{referenceNumber}</div>
                                                <ButtonTw
                                                    color="primary"
                                                    className="w-full"
                                                    onClick={() => onCloseModal()}
                                                >
                                                    Cerrar
                                                </ButtonTw>
                                            </div>
                                        </div>
                                    )}
                                </TextContent>
                            </TextColumn>
                        </TwoColumn>
                    </Container>
                    <Footer />
                </AnimationRevealPage>
            )}
        </>
    );
}
